import { normalizeStatusKey } from '../../utils/statusFormat';

// NEW: UI_REVAMP
export const TRANSACTION_TEXT_COLOR = '#0052FF';

export const getTransactionStatusStyle = (status = '') => {
	const normalizedStatus = normalizeStatusKey(status);

	if (normalizedStatus === 'strike' || normalizedStatus === 'bettingstrike') {
		return {
			label: 'Strike',
			minWidth: '66px',
			background: 'linear-gradient(180deg, #01A13D 0%, #09632B 100%)',
			color: '#FFFFFF',
		};
	}

	if (normalizedStatus === 'topup' || normalizedStatus.startsWith('topupfor')) {
		return {
			label: 'Topup',
			minWidth: '69px',
			background: '#D9F7E1',
			color: '#078633',
		};
	}

	if (normalizedStatus === 'withdraw' || normalizedStatus === 'withdrawal') {
		return {
			label: 'Withdrawal',
			minWidth: '105px',
			background: '#EBD1FF',
			color: '#C02CFF',
		};
	}

	if (normalizedStatus === 'voided' || normalizedStatus === 'bettingvoided') {
		return {
			label: 'Voided',
			minWidth: '74px',
			background: '#FFCFCF',
			color: '#FF3333',
		};
	}

	if (normalizedStatus === 'betting') {
		return {
			label: 'Betting',
			minWidth: '76px',
			background: '#FDE1BA',
			color: '#FF9D20',
		};
	}

	if (normalizedStatus === 'denied' || normalizedStatus === 'bettingdenied') {
		return {
			label: 'Denied',
			minWidth: '74px',
			background: '#BDBDBD',
			color: '#777777',
		};
	}

	return {
		label: status,
		minWidth: '66px',
		background: '#ECF2FF',
		color: TRANSACTION_TEXT_COLOR,
	};
};
